import type { AdminRoles } from '@/constants/UserPermission';

/**
 * Unique union of direct user roles and inherited team roles.
 * Order preserves userRoles first, then teamRoles not already present.
 */
export function getEffectiveUserRoles(
  user: {
    userRoles?: AdminRoles[];
    team?: { teamRoles?: AdminRoles[] };
  } | null,
): AdminRoles[] {
  if (!user) {
    return [];
  }

  return [...new Set([...(user.userRoles ?? []), ...(user.team?.teamRoles ?? [])])];
}
